// extracted by mini-css-extract-plugin
export default {"name":"AssetRow__name-uYhyK","description":"AssetRow__description-ND55Q","menu":"AssetRow__menu-Inb_C"};